import React from 'react';
import {Button, Card, CardBody, CardGroup, Col, Container, Row} from "reactstrap";
import {Input} from "semantic-ui-react";
import Login_ICON from "../../../assets/img/login.png";
import * as common from "../../../const/Common/CommonFunc";
import * as validator from "../../../util/Validator";
import axios from "../../../axios/axios_authorization";
import apiConfig from "../../../axios/axios_api_services";
import Cookies from "js-cookie";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import IntlTelInput from "react-intl-tel-input";
import './Login.scss';
import * as config from "../../../const/config/config";
import * as qs from "qs";
import * as keys from "../../../const/key/Key";
import * as routeConstants from "../../../const/route/Route";

class App extends React.Component {

  state = {
    guestMobile: "",
    guestOriMobile: "",
    guestPIN: "",
    switch: false, expireTime: 30, isValidNo: false, pinRequired: true, userExist: false
  };

  onHandleChange = name => e => {
    let value = e.target.value;
    switch (name) {
      case 'guestPIN':
        this.setState({guestPIN: value});
        break;
      default:
        break;
    }
  };

  onHandleChangeHostMobile = (condition, value, object, withdialcod) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    condition = validator.customMobileValidation(withdialcod.substr(1).replace(/\s/g, ""),condition);

    this.setState({guestMobile: withdialcod.substr(1).replace(/\s/g, ""), guestOriMobile: value, isValidNo: condition});
  };

  onSwitch = (condition) => {
    this.setState({guestPIN: "", switch: condition, expireTime: condition ? 30 : 0});
  };

  checkMobileNumberExist = () => {
    let {guestMobile, isValidNo, pinRequired} = this.state;
    let guestStatus = localStorage.getItem(keys.GUEST_STATUS);


    if (!pinRequired && guestStatus !== keys.STATUS_GUEST_NEW_PUBLIC_USER) {
      common.notifyMessage("Please re-scan QR code", 0, 3);
      return;
    }

    if (isValidNo) {
      this.props.spinnerHandler(true);

      axios.get(apiConfig.GUEST_USER_CHECK_MOBILE_NUMBER_EXIST(guestMobile, true))
        .then(response => {
          if (response.data.success) {

            // if (!pinRequired) {
            //   common.warningAlert("You have already registered with the platform", 0);
            //   return;
            // }

            this.setState({
              userExist: response.data.success
            });
            this.onSwitch(true);

          } else {
            if (response.data.error_code) {
              common.warningAlert(response.data.message, 1)
            } else {
              this.props.history.push({
                pathname: `${routeConstants.GUEST_ROUTE_PATH}/register`,
                state: {mobile: guestMobile, pinRequired: pinRequired}
              });
            }
          }
        })
        .catch(error => {
          common.checkErrorResponse(error);
        })
        .finally(fin => {
          this.props.spinnerHandler(false);
        })
    } else {
      common.notifyMessage("Please enter valid mobile number")
    }
  };

  onSubmitToVerifyOTP = () => {
    if (this.state.guestPIN.trim() !== '') {
      if (this.state.userExist) {
        this.authHandler();
      }
    } else {
      common.notifyMessage("Please enter verification code")
    }
  };

  authHandler = () => {
    let {guestMobile, guestPIN,pinRequired} = this.state;

    this.props.spinnerHandler(true);
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      "Authorization": "Basic " + config.CLIENT_SECRET
    };

    const data = {
      username: guestMobile,
      password: guestPIN,
      grant_type: 'password'
    };

    axios.post(apiConfig.OAUTH, qs.stringify(data), {headers: headers})
      .then(response => {
        this.props.spinnerHandler(false);

        Cookies.set(keys.ACCESS_TOKEN, response.data.access_token); //access-token
        Cookies.set(keys.REFRESH_TOKEN, response.data.refresh_token); // refresh-token
        localStorage.setItem(keys.GUEST_CACHE, "1");

        this.props.userHandler(response.data.user);
        this.props.history.push(`${routeConstants.GUEST_ROUTE_PATH}/profile`)
      })
      .catch(error => {
        this.props.spinnerHandler(false);
        if (error.status === 403) {
          common.notifyMessage(error.statusDesc, 0, 3);
        } else {
          common.notifyMessage("This PIN does not valid ", 0, 3);
        }
      });
  };
  countDown = () => {
    let {expireTime} = this.state;
    if (this.state.switch && expireTime > 0) {
      this.setState({expireTime: (expireTime - 1)})
    }
  };

  componentDidMount() {
    this.timer = setInterval(this.countDown, 1000);
    let branchId = localStorage.getItem(keys.GUEST_BRANCH_ID);
    let pinRequired = branchId !== null;
    this.setState({pinRequired: pinRequired})
  }
  customPlaceholder = (selectedCountryPlaceholder) => {
    return selectedCountryPlaceholder.substr(0,2) + "XXXXXXXX";
  };
  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    let {expireTime, userExist, pinRequired} = this.state;
    return (
      <div className={"app flex-row align-items-center login-background animated bounceInLeft user-login"}>
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup style={{boxShadow: '0 30px 60px 0 rgba(0,0,0,0.3)'}}>

                <Card className="p-4" style={{border: 'none'}}>
                  {
                    !this.state.switch ?
                      <CardBody>
                        {/*<h1>{pinRequired ? `Login`:`Registration`}</h1>*/}
                        <p className={"head-title"}><span className={"lng-eng"}>Registration</span> / <span className={"lng-sin"}>ලියාපදිංචි කිරීම</span> / <span
                          className={"lng-tml"}>பதிவீடு</span></p>

                        <p className="text-muted">
                          <span className={"lng-eng"}>Enter your mobile number to register </span><br/>
                          <span className={"lng-sin"}>ලියාපදිංචි වීමට ඔබගේ ජංගම දුරකථන අංකය ඇතුළත් කරන්න</span><br/>
                          <span className={"lng-tml"}>பதிவு செய்ய உங்கள் கைபேசி எண்ணை உள்ளிடவும்</span>
                        </p>

                        <div>
                          <IntlTelInput
                            style={{width: '100%', marginBottom: '15px', marginTop: '15px'}}
                            type={"text"}
                            fieldName={"Mobile Number"}
                            value={this.state.guestOriMobile}
                            containerClassName="intl-tel-input dashboard-intl"
                            inputClassName="form-control"
                            onPhoneNumberChange={this.onHandleChangeHostMobile}
                            required={true}
                            preferredCountries={['lk']}
                            defaultCountry={"lk"}
                            nationalMode={true}
                            icon='mobile alternate'
                            customPlaceholder={this.customPlaceholder}
                          />
                        </div>

                        <Row>
                          <Col lg='12' md='12' xs="12">
                            <br/>
                            <Button
                              onClick={this.checkMobileNumberExist}
                              className="ui button px-5"
                            >Continue
                            </Button>
                          </Col>
                        </Row>

                      </CardBody>
                      :
                      <CardBody>
                        {/*<h1>OTP Verification</h1>*/}
                        <p className={"head-title"}><span className={"lng-eng"}>OTP Verification</span></p>
                        {/*<br/>*/}
                        <p className="warning-muted">
                          {`We've sent a verification code to your ${this.state.guestMobile} mobile via SMS. Please provide it below`}</p>

                        <div>
                          <Input
                            focus={true}
                            style={txtStyle}
                            className={"login-username xd"}
                            placeholder='Enter verification code'
                            onChange={this.onHandleChange("guestPIN")}
                          />
                          <p className={"align-right"}
                             style={{color: 'gray', textDecoration: 'underline', cursor: "pointer"}}
                             onClick={() => this.onSwitch(false)}>Change Mobile</p>
                        </div>
                        <br/>
                        <div className={"align-center|"}>
                          {expireTime === 0 &&
                          <p className={"expire-text"}>{"Didn't receive the code? "} <label className={'resend-text'}
                                                                                            onClick={() => this.checkMobileNumberExist(true)}>Resend</label>
                          </p>}
                          {expireTime !== 0 && <p className={"expire-text"}>Didn't receive the code?
                            00:<label>{expireTime < 10 ? `0${expireTime}` : expireTime}</label></p>}
                        </div>

                        <Row>
                          <Col lg='12' md='12' xs="12" className={"align-center|"}>
                            <Button
                              onClick={this.onSubmitToVerifyOTP}
                              className="ui button px-5"
                            >
                              {
                                userExist ? `Verify and Login` : `Continue`
                              }
                            </Button>
                          </Col>
                        </Row>

                      </CardBody>
                  }

                </Card>
                <Card className="text-white  py-5 d-md-down-none login-right-side"
                      style={{border: 'none', width: '44%', height: '301px'}}>

                  <img src={Login_ICON} style={{width: '100%', height: '180%', objectFit: 'contain'}} alt={"."}/>

                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

let txtStyle = {
  marginBottom: '10px',
  height: '45px',
  width: '100%'

};

const mapStateToProps = (state) => ({
  is_spin: state.spinnerReducer.is_spin,
  guest_data: state.guestUserReducer.guestUser
});

const mapDispatchToProps = (dispatch) => {
  return {
    callAllBuildings: (data) => dispatch(actionCreator.callAllBuildings(data)), // Get All Buildings Of Corporate

    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // all floors
    receptionAllFloorHandler: (data) => dispatch(actionCreator.receptionAllFloorHandler(data)),
    // all building
    receptionAllBuildingHandler: (data) => dispatch(actionCreator.receptionAllBuildingHandler(data)),
  };

}

export default connect(mapStateToProps, mapDispatchToProps)(App);
